import React from 'react';
import PropTypes from 'prop-types';
import {connect} from 'react-redux';
import MenuItem from '@material-ui/core/MenuItem';
import CampaignFilterFilter from './CampaignFilterFilter';
import FormControl from '@material-ui/core/FormControl';
import InputLabel from '@material-ui/core/InputLabel';
import Select from '@material-ui/core/Select';
import TextField from '@material-ui/core/TextField';
import {useTranslation} from 'react-i18next';

const FILTER_EQUALS = 'equals';
const FILTER_NOT_EQUALS = 'not-equals';
const FILTER_CONTAINS = 'contains';
const FILTER_GREATER_THAN = 'greater-than';
const FILTER_LESS_THAN = 'less-than';
const FILTER_BETWEEN = 'between';

const getSelectedAttributeType = (attributes, selectedAttributeId) => {
    if (!attributes.loaded || !selectedAttributeId) return 'string';
    const found = attributes.data.find(a => a['@id'] === selectedAttributeId);
    return found ? (found.type || 'string') : 'string';
};

const getFilterOptions = (attributeType, t) => {
    const common = [
        {value: FILTER_EQUALS, label: t('Equals')},
        {value: FILTER_NOT_EQUALS, label: t('Not equals')},
    ];

    if (attributeType === 'numeric' || attributeType === 'date') {
        return [
            ...common,
            {value: FILTER_GREATER_THAN, label: t('Greater than')},
            {value: FILTER_LESS_THAN, label: t('Less than')},
            {value: FILTER_BETWEEN, label: t('Between')},
        ];
    }

    return [
        ...common,
        {value: FILTER_CONTAINS, label: t('Contains')},
    ];
};

const CampaignFilterAttributeAttributes = (
    {
        attributes,
        filter: {
            attribute,
            filter: filterType,
            value
        },
        index,
        onUpdate
    }
) => {
    const {t} = useTranslation();
    const attributeType = getSelectedAttributeType(attributes, attribute);
    const filterOptions = getFilterOptions(attributeType, t);

    const attributeUpdateHandler = (event) => {
        const newAttribute = event.target.value;
        const newType = getSelectedAttributeType(attributes, newAttribute);
        const validFilters = getFilterOptions(newType, t).map(o => o.value);
        const updates = {attribute: newAttribute};
        if (!validFilters.includes(filterType)) {
            updates.filter = FILTER_EQUALS;
        }
        onUpdate(index, updates);
    };
    const filterTypeUpdateHandler = (filter) => onUpdate(index, {filter});
    const valueUpdateHandler = (event) => onUpdate(index, {value: event.target.value});

    const mapAttributes = () => attributes.data.map(
        (attribute, index) => <MenuItem key={index} value={attribute['@id']}>{attribute.name}</MenuItem>);

    const valueInputType = attributeType === 'numeric' ? 'number' : attributeType === 'date' ? 'date' : 'text';
    const valueLabel = filterType === FILTER_BETWEEN
        ? t('Value (e.g. %{example})', {example: attributeType === 'date' ? '2024-01-01,2024-12-31' : '10,50'})
        : t('Value');

    return (
        <>
            {attributes.loaded &&
                <div style={{marginRight: '20px'}}>
                    <FormControl>
                        <InputLabel htmlFor='type'>{t('Contact Attributes')}</InputLabel>
                        <Select
                            value={attribute}
                            onChange={attributeUpdateHandler}
                            inputProps={{
                                name: 'attribute',
                                id: 'attribute',
                            }}
                            style={{
                                minWidth: '250px'
                            }}
                        >
                            {mapAttributes()}
                        </Select>
                    </FormControl>
                </div>}
            <CampaignFilterFilter value={filterType} onChange={filterTypeUpdateHandler}>
                {filterOptions.map(option => (
                    <MenuItem key={option.value} value={option.value}>{option.label}</MenuItem>
                ))}
            </CampaignFilterFilter>
            <TextField id={'value'}
                       label={valueLabel}
                       type={filterType === FILTER_BETWEEN ? 'text' : valueInputType}
                       style={{width: '100%'}}
                       value={value}
                       onChange={valueUpdateHandler}
                       InputLabelProps={attributeType === 'date' && filterType !== FILTER_BETWEEN ? {shrink: true} : undefined}
            />
        </>
    );
}

CampaignFilterAttributeAttributes.propType = {
    filter: PropTypes.object.isRequired,
    index: PropTypes.number.isRequired,
    onUpdate: PropTypes.func.isRequired,
}

CampaignFilterAttributeAttributes.propTypes = {
    filter: PropTypes.object.isRequired,
}

const mapStateToProps = (state) => ({
    attributes: state.campaign.wizard.attributes,
});

export default connect(mapStateToProps)(CampaignFilterAttributeAttributes);
